import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    arrEmailTemplate: []
};
const getters = {
    listingEmailTemplate: () => state.arrEmailTemplate
};

const actions = {
    [actionType.GET_EMAIL_TEMPLATE]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/admin/email-templates', {
                params: {
                    page: params.page,
                    take: params.take,
                    search: params.search
                }
            }).then(result => {
                if(result.data.data) {
                    let response = {
                        page: params.page,
                        data: result.data.data
                    }
                    commit(mutationType.SET_EMAIL_TEMPLATE, response)
                }
                resolve(result)
            })
            .catch(error => reject(error));
        });
    }
};

const mutations = {
    [mutationType.SET_EMAIL_TEMPLATE]: function (state, data) {
        if(data.data.length > 0) {
            if(data.page == 1) {
                state.arrEmailTemplate = data.data
            }
            else {
                state.arrEmailTemplate = state.arrEmailTemplate.concat(data.data);
            }
        }
    },
    "RESET_LISTING_EMAIL_TEMPLATE": function (state) {
        state.arrEmailTemplate = []
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}